import { useRestClient } from '@/contexts/QueryProvider'
import { DirectLinkedUserCardV2 } from './DirectLinkedUserCardV2'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { WorkspaceUsersForm } from '../Forms/WorkspaceUsersForm'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { SectionContainer } from '../../shared-components/SectionContainer'

export function DirectLinkedUsersSection() {
  const workspace = useCurrentWorkspace()
  const { workspaceId, project_id: projectId } = workspace
  const { getWorkspacesApiGetUsers } = useRestClient()

  const {
    data: projectUsers,
    // isPending: usersPending,
    // isError: usersError,
  } = getWorkspacesApiGetUsers.useQuery({
    query: { workspaceId },
  })

  return (
    <SectionContainer
      title="Direct linked users"
      description="Add or remove users from the workspace and manage their roles."
      action={
        <WorkspaceUsersForm
          sheetTitle="Add User to Workspace"
          sheetDescription="Add a user to the workspace."
          sheetTriggerTooltip="Add a user to the workspace"
          sheetTrigger={
            <Button variant="ghost" size="icon">
              <IconPlusOutline />
              <span className="sr-only">Add user</span>
            </Button>
          }
        />
      }
    >
      <div className="grid grid-cols-1 gap-4 py-3 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
        {projectUsers?.map((user) => (
          <DirectLinkedUserCardV2
            key={user.id}
            user={user}
            editEnabled={true}
            projectId={projectId}
            workspaceId={workspaceId}
          />
        ))}
      </div>
    </SectionContainer>
  )
}
